<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 100px;">
  <app-dashboard-card #compDetailCard [collapsedOnMobile]="true" *ngIf="companyDetailsCard" [dashboardCard]="companyDetailsCard"
                      [headerIcon]="'map-marked-alt'" [cardHeader]="compCardHeader" [collapsedCardHeader]="compCollapsedCardHeader"
                      [ngClass]="'col-' + companyDetailsCard.columnSize" [cardHeaderAction]="cardHeaderAction"
                      [panelIcons]="compCardIcons" [collapsedPanelIcons]="compCollapsedCardIcons">
    <ng-template #compCardHeader>
      Enterprise Details
    </ng-template>

    <ng-template #compCollapsedCardHeader>
      Enterprise Details <span class="hide-on-small-screens">- {{company.companyName}} - {{company.contactName}}</span>
    </ng-template>
    <ng-template #cardHeaderAction>
      <app-eca-ghost-btn class="card-action-icon" *ngIf="editingCompanyDetails"
                         btnText="Cancel" btnIcon="times" btnType="danger"
                         (btnClicked)="cancelEditCompanyDetails()">
      </app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon" *ngIf="editingCompanyDetails"
                         btnText="Save" btnIcon="save" btnType="success"
                         (btnClicked)="saveCompanyDetails()">
      </app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon" *ngIf="!editingCompanyDetails && isTrialCompany" [disable]="loadingCompanyDetails"
                         btnText="Edit" btnIcon="edit" (btnClicked)="editCompanyDetails()">
      </app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon"
                         btnIcon="question-circle" btnType="warning"
                         (btnClicked)="openCompanyHelp()">
      </app-eca-ghost-btn>
    </ng-template>

    <div class="container-fluid">
      <div *ngIf="loadingCompanyDetails" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!loadingCompanyDetails">
        <app-company-details [company]="company" [editing]="editingCompanyDetails"></app-company-details>
      </div>
    </div>
  </app-dashboard-card>


  <app-dashboard-card *ngIf="operativesListCard" [dashboardCard]="operativesListCard" [headerIcon]="'users'"
                      [cardHeader]="opsCardHeader" [collapsedCardHeader]="opsCollapsedCardHeader"
                      [headerText]="'Current Operatives'" [ngClass]="'col-' + operativesListCard.columnSize"
                      [cardHeaderAction]="cardHeaderAction">
    <ng-template #opsCardHeader>
      Current Operatives
    </ng-template>
    <ng-template #opsCollapsedCardHeader>
      <span class="hide-on-small-screens">{{operatives?.length}}</span> Current Operatives
    </ng-template>
    <ng-template #cardHeaderAction>
      <app-eca-ghost-btn class="card-action-icon" *ngIf="!editingCompanyDetails && loggedInUser?.operativeOperations?.canInsert" btnText="Add New" btnIcon="plus-circle"
                         btnType="success" (click)="addOperative()" [disable]="loadingOperatives"></app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon" *ngIf="!editingCompanyDetails" btnText="Manage"
                         btnIcon="search" (click)="gotoOperativesPage()" [disable]="loadingOperatives"></app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon" btnText="EAS" btnIcon="bolt" btnType="warning" [disable]="loadingOperatives" (btnClicked)="openRiskHelp()"></app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon"
                         btnIcon="question-circle" btnType="warning"
                         (btnClicked)="openOperativesHelp()"></app-eca-ghost-btn>

    </ng-template>

    <div class="container-fluid" style="padding-left: 0; padding-right: 0">
      <div *ngIf="loadingOperatives" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!loadingOperatives">
        <app-operative-list [operatives]="operatives" [allJobLevels]="allJobLevels" [allEmploymentStatuses]="allEmploymentStatuses" [allRisks]="allRisks"
                            [companyJobTitles]="allCompanyJobTitles"
                            [showRowControllerButtons]="false"
                            [allowedOperations]="loggedInUser?.operativeOperations"
                            [showFilters]="false" [showTitleBar]="false" [showMultiSelect]="false"
                            [showOperativeMenus]="!editingCompanyDetails"></app-operative-list>
      </div>

    </div>
  </app-dashboard-card>

  <app-dashboard-card *ngIf="recentObservationsListCard" [dashboardCard]="recentObservationsListCard"
                      [cardHeader]="obsCardHeader" [collapsedCardHeader]="obsCollapsedCardHeader"
                      [headerIcon]="'eye'"
                      [ngClass]="'col-' + recentObservationsListCard.columnSize"
                      [cardHeaderAction]="cardHeaderAction">
    <ng-template #obsCardHeader>
      Recent Observations
    </ng-template>
    <ng-template #obsCollapsedCardHeader>
      <span class="hide-on-small-screens">{{recentObservations?.length}}</span> Recent Observations
    </ng-template>
    <ng-template #cardHeaderAction>
      <app-eca-ghost-btn class="card-action-icon" *ngIf="!editingCompanyDetails" btnText="Enterprise Observations" btnIcon="search"
                         (btnClicked)="goToCompanyObservations()" [disable]="loadingObservations"></app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon" *ngIf="!editingCompanyDetails" btnText="Operative Observations" btnIcon="search"
                         (btnClicked)="goToOperativeObservations()" [disable]="loadingObservations"></app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon"
                         btnText="" btnIcon="question-circle" btnType="warning"
                         (btnClicked)="openObservationsHelp()"></app-eca-ghost-btn>
    </ng-template>
    <div class="container-fluid" style="padding-left: 0; padding-right: 0">
      <div *ngIf="loadingObservations" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!loadingObservations">
        <app-recent-observations-list [recentObservations]="recentObservations"
                                      (viewObservationClicked)="viewObservation($event)"
                                      (editObservationClicked)="editObservation($event)"
                                      (deleteObservationClicked)="deleteObservation($event)" [allowDelete]="false" [allowEdit]="false"></app-recent-observations-list>
      </div>
    </div>
  </app-dashboard-card>

  <app-dashboard-card *ngIf="recentDocumentsCard" [dashboardCard]="recentDocumentsCard"
                      [cardHeader]="docCardHeader" [headerIcon]="'books'" [collapsedCardHeader]="docCollapsedCardHeader"
                      [ngClass]="'col-' + recentDocumentsCard.columnSize"
                      [cardHeaderAction]="cardHeaderAction">
    <ng-template #docCardHeader>
      Recent Documents
    </ng-template>
    <ng-template #docCollapsedCardHeader>
      <span class="hide-on-small-screens">{{companyDocumentSummaries?.length}}</span> Recent Documents
    </ng-template>
    <ng-template #cardHeaderAction>
      <app-eca-ghost-btn class="card-action-icon" btnText="Add Enterprise Document"
                         (btnClicked)="addCompanyDocument()" btnIcon="plus-circle" [disable]="documentsLoading"
                         *ngIf="!editingCompanyDetails && loggedInUser?.documentOperations?.canInsert"
                         btnType="success"></app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon" *ngIf="!editingCompanyDetails" btnText="Manage" btnIcon="search"
                         [routerLink]="'/company-documents'" [disable]="documentsLoading"></app-eca-ghost-btn>
      <app-eca-ghost-btn class="card-action-icon"
                         btnIcon="question-circle" btnType="warning"
                         (btnClicked)="openRecentDocumentsHelp()"></app-eca-ghost-btn>
    </ng-template>
    <div class="container-fluid" style="padding-left: 0; padding-right: 0">
      <div *ngIf="documentsLoading" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!documentsLoading">
        <app-companies-documents-lists *ngIf="companyDocumentSummaries" [documentSummaryInfos]="companyDocumentSummaries"
                                       (downloadCompanyDocument)="downloadCompanyDocument($event)" (refreshDocumentsRequested)="getCompanyDocumentSummaries($event)"
                                       [allowEdit]="false" [allowDelete]="false"
                                       (openCompanyDocument)="openCompanyDocument($event)">
        </app-companies-documents-lists>
      </div>
    </div>
  </app-dashboard-card>
  <app-eca-app-version></app-eca-app-version>
</div>
